import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { useEffect } from "react";
import { useAppSelector } from "../../redux";
import { selectText } from "../LanguageSelect/LanguageSelectSlice";
import { Grid } from "@mui/material";
import { useStyles } from "./ModalHooks";
import { EmailModal } from "./EmailModal/EmailModal";
import { PhoneModal } from "./PhoneModal/PhoneModal";
import { AddressModal } from "./AddressModal/AddressModal";

interface CustomModalProps {
  modal: boolean;
  handleClose(): void;
  type: string | null;
}

export function CustomModal(props: CustomModalProps) {
  const { modal, handleClose, type } = props;
  const { modalStyle } = useStyles();

  const text = useAppSelector(selectText);

  useEffect(() => {
    if (!type) {
      handleClose();
    }
  }, [type]);

  const renderFields = (type: string | null) => {
    switch (type) {
      case "email": {
        return <EmailModal handleClose={handleClose} />;
      }
      case "phone": {
        return <PhoneModal handleClose={handleClose} />;
      }
      case "address": {
        return <AddressModal handleClose={handleClose} />;
      }
      default: {
        <Typography>"nothing to render"</Typography>;
      }
    }
  };

  const renderTitle = (type: string | null) => {
    switch (type) {
      case "email": {
        return (
          <Typography variant="h3" textAlign={"center"}>
            {text.formsFeilds.email}
          </Typography>
        );
      }
      case "phone": {
        return (
          <Typography variant="h3" textAlign={"center"}>
            {text.formsFeilds.phone}
          </Typography>
        );
      }
      case "address": {
        return (
          <Typography variant="h3" textAlign={"center"}>
            {text.formsFeilds.addressTitle}
          </Typography>
        );
      }
    }
  };

  return (
    <Modal
      open={modal}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{}}
    >
      <Grid sx={modalStyle} container spacing={3} direction="row" justifyContent="flex-start" alignItems="center">
        <Grid item xs={12} xl={12}>
          {renderTitle(type)}
        </Grid>
        <Grid item xs={12} xl={12}>
          {renderFields(type)}
        </Grid>
      </Grid>
    </Modal>
  );
}
